<dynamic-form
  [apiName]="apiName"
  [label]="label"
  [group]="formGroup"
  [areaName]="areaName"
  [model]="model"
  [columns]="columns"
  (valueChange)="valueChange($event)"
  (cancelChange)="cancel()"
  hasfocus="Title"
  [noSubmit]="deactivateSave"
  (submitChange)="save()">
  <ng-container class="footer">
    <div *ngIf="haserror" class="alert alert-danger">
      <div [hidden]="!haserror">
        {{ erroremessage }}
      </div>
    </div>
  </ng-container>
  <ng-container class="content">
    <ssg-tabset
      (tabChange)="selectTab($event)"
      class="tabcontainer tabcontentbox"
      *ngIf="isAccessToAllBranches && Branches?.length > 0 && model?.Branches?.length > 0 && showBranch">
      <ssg-tab [tabTitle]="'ClientApp.FrontOffice.Parties.Zone.Branches' | translate">
        <editable-grid
          [DefaultValues]="DefaultValues"
          [columns]="Branches"
          [dataList]="model.Branches"
          [isAdd]="false"
          [isDelete]="false"
          (afterSaved)="afterSaveRow($event)">
        </editable-grid>
      </ssg-tab>
    </ssg-tabset>
  </ng-container>
</dynamic-form>
